import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@falcon/env';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { InvoiceModel } from '@falcon/app/shared/models/invoice.model';
import { PageableResponsePayloadModel } from '@falcon/app/shared/models/pageable-response-payload.model';
import { BaseApi } from '../models/base-api';
import { InvoicesRequestParamsModel } from './invoices-requests-params.model';

@Injectable({
  providedIn: 'root',
})
export class InvoiceService extends BaseApi {
  private http = inject(HttpClient);

  private readonly INVOICES_API_URL = `${environment.apiURL}/invoices`;

  getInvoices(params: InvoicesRequestParamsModel): Observable<InvoiceModel[]> {
    return this.http
      .get<PageableResponsePayloadModel<InvoiceModel[]>>(this.INVOICES_API_URL, {
        params: this.mapParamsToString(params),
      })
      .pipe(map(res => res.content));
  }
}
